import i18n from "i18next";

export function findMobileAppUrl(config) {
    if (!config) return null;

    let url = config[i18n.language];
    if (!url) url = config[""];
    return url ? url : null;
}
